import { Component, OnInit, Input, Output, EventEmitter, forwardRef }           from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { JourneysService }            from './../../journeys.service';
import { JourneyDetail }              from './../../../../models/journey/journey-detail';

@Component({
  selector: 'app-clone-journey',
  templateUrl: './clone-journey.component.html',
  styleUrls: ['./clone-journey.component.less'],
  providers: [JourneysService]
})

export class CloneJourneyComponent implements OnInit {
  journeys: {id: number, name: string, edition: {id: number, name: string}}[];
  loaded: boolean;
  @Input() saving?: boolean;
  @Input() alerts?: string[]
  @Output() update: EventEmitter<{journeyId: number, editionId: number}> = new EventEmitter<{journeyId: number, editionId: number}>();
  public clone: FormGroup;

  constructor(
    private journeysService: JourneysService,
    private _fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.journeysService
      .getCloneableJourneys()
      .subscribe((journeys) => {
        this.journeys = journeys;
        this.loaded = true;
      });

    this.clone = this._fb.group({
      selectedJourney: [null, <any>Validators.required]
    });
  }

  public cloneJourney(): void {
    this.update.emit(this.clone.controls.selectedJourney.value);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/journeys/journey/clone-journey/clone-journey.component.ts